import { Button } from "@/components/ui/button";
import { MerchProduct } from "../models/merch";
import { formatPrice } from "@/lib/string";
import { useNavigate } from "react-router-dom";
import { MerchRoute } from "@/features/home/route";

function ProductCard({ product }: { product: MerchProduct }) {
	const navigate = useNavigate();
	const primaryColor = product.colors[0];
	const image = primaryColor?.image;

	const handleClick = () => {
		navigate(`${MerchRoute}/${product.slug}`);
	};

	return (
		<div className="flex flex-col gap-6 rounded-[32px] bg-white p-6 shadow-sm">
			<div
				className={`h-56 w-full rounded-[24px] bg-cover bg-center ${
					image ? "" : "bg-gray-100"
				}`}
				style={image ? { backgroundImage: `url('${image}')` } : undefined}
			/>
			<div className="flex flex-col gap-4">
				<div className="flex flex-col gap-2">
					{product.tagline && (
						<p className="web-body-b2 text-gray-500">{product.tagline}</p>
					)}
					<p className="web-heading-h4">{product.name}</p>
					<p className="web-heading-h4 text-blue-500">
						{formatPrice(product.price, product.currencyCode)}
					</p>
				</div>

				<div className="flex flex-col gap-3">
					{product.colors.length > 0 && (
						<div className="flex flex-row flex-wrap items-center gap-2">
							<span className="web-body-b2 text-gray-500">Colors:</span>
							{product.colors.map((color) => (
								<span
									key={color.name}
									className="h-5 w-5 rounded-full border border-white shadow-[0_0_0_1px_rgba(0,0,0,0.1)]"
									style={{ backgroundColor: color.hex ?? "#E5E7EB" }}
									title={color.name}
								/>
							))}
						</div>
					)}
					{product.variants.map((variant) => (
						<div key={variant.name} className="flex flex-wrap items-center gap-2">
							<span className="web-body-b2 text-gray-500">{variant.name}:</span>
							{variant.values.map((value) => (
								<span
									key={value}
									className="rounded-full border border-gray-200 px-3 py-1 text-xs text-gray-700"
								>
									{value}
								</span>
							))}
						</div>
					))}
				</div>

				<Button onClick={handleClick} variant="secondary">
					View Product
				</Button>
			</div>
		</div>
	);
}

export default ProductCard;
